// extracted by mini-css-extract-plugin
export default {"btn":"FollowButton_btn__s+HYZ"};